import React from "react";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import usePalmares from "./hooks/usePalmares";

import PalmaresHeader from "./components/PalmaresHeader";
import PalmaresStats from "./components/PalmaresStats";
import PalmaresTable from "./components/PalmaresTable";
import PalmaresFormDrawer from "./components/PalmaresFormDrawer";

const Palmares = ({ sectionId }) => {
  const {
    finalSectionId,
    rows,
    stats,
    years,
    loading,
    saving,
    demoMode,

    searchTerm,
    setSearchTerm,
    yearFilter,
    setYearFilter,
    statusFilter,
    setStatusFilter,

    drawer,
    openCreateDrawer,
    openEditDrawer,
    closeDrawer,

    fetchPalmares,
    handleCreate,
    handleUpdate,
    handleDelete,
  } = usePalmares(sectionId);

  return (
    <section className="w-full pb-10 font-satoshi">
      <div className="mx-auto max-w-[1400px] space-y-5">
        <PalmaresHeader
          loading={loading}
          demoMode={demoMode}
          sectionId={finalSectionId}
          onRefresh={fetchPalmares}
          onCreate={openCreateDrawer}
        />

        <PalmaresStats stats={stats} />

        <PalmaresTable
          rows={rows}
          years={years}
          loading={loading}
          searchTerm={searchTerm}
          yearFilter={yearFilter}
          statusFilter={statusFilter}
          onSearchChange={setSearchTerm}
          onYearFilterChange={setYearFilter}
          onStatusFilterChange={setStatusFilter}
          onEdit={openEditDrawer}
          onDelete={handleDelete}
        />
      </div>

      <PalmaresFormDrawer
        isOpen={drawer.type === "create"}
        mode="create"
        saving={saving}
        onClose={closeDrawer}
        onCreate={handleCreate}
      />

      <PalmaresFormDrawer
        isOpen={drawer.type === "edit"}
        mode="edit"
        palmares={drawer.palmares}
        saving={saving}
        onClose={closeDrawer}
        onUpdate={handleUpdate}
      />

      <ToastContainer position="top-right" autoClose={2500} theme="colored" />
    </section>
  );
};

export default Palmares;